import nestedComponentForm from 'formiojs/components/_classes/nested/NestedComponent.form';
import { CustomComponentType } from '../../../enums';
import { BaseEdit } from '../../configuration-components/base-widget-configuration';

export default function(...extend: any) {
	return nestedComponentForm(BaseEdit.getTabs(CustomComponentType.coBorrowerEntity), ...extend);
}
